<script setup lang="ts">
import MapMarkerIcon from "./MapMarkerIcon.svg";
</script>

<template>
  <MapMarkerIcon class="map-marker-icon" />
</template>
